import {DetailsFieldsGrid} from '@/components/ui/details-atoms/DetailsAtoms'
import styled, {css} from 'styled-components'

export const StyledUserDetailsFieldsGrid = styled(DetailsFieldsGrid)(
    ({theme: {mediaQueries}}) => css`
        grid-template-columns: repeat(4, 1fr);
        font-weight: 500;
        ${mediaQueries.xl} {
            grid-template-columns: repeat(2, 1fr);
        }
    `
)
